import { API_PERMISSIONS } from "../_ApiPermissions";


const EXTRA_PERMISSIONS = API_PERMISSIONS.EXTRA;
const STANDARD_ACTIONS = API_PERMISSIONS.ACTIONS;


export const buildModuleApi = (OBJ = {}) => {

    const { prefix, uri, overrides = {}, exclude = [], extraActions = {},
        extraPermissions = [], withExtra = true } = OBJ;

    if (!prefix || !uri) {
        throw new Error("buildModuleApi: prefix y uri son requeridos.");
    }

    const allActions = { ...STANDARD_ACTIONS, ...extraActions };

    const filteredActions = Object.fromEntries(
        Object.entries(allActions).filter(([key]) => !exclude.includes(key))
    );

    const API = {};

    for (const [actionKey, def] of Object.entries(filteredActions)) {
        const override = overrides[actionKey] ?? {};
        const rawPermission = override.permission ?? def.permission ?? null;

        API[actionKey] = {
            KEY: `${prefix}__${actionKey}`, URL: override.url ?? `/${uri}${def.suffix}`,
            PERMISSION: rawPermission ? `${prefix}__${rawPermission}` : null,
        };
    }

    const permissionSet = new Set();
    Object.values(API).forEach((action) => {
        if (!action.PERMISSION) return;
        const suffix = action.PERMISSION.replace(`${prefix}__`, "");
        permissionSet.add(suffix);
    });

    if (withExtra) {
        EXTRA_PERMISSIONS.forEach((p) => permissionSet.add(p));
    }
    extraPermissions.forEach((p) => permissionSet.add(p));

    const PERMISSIONS = Object.fromEntries([...permissionSet].map((p) => [p, `${prefix}__${p}`]));

    // CONSTANTS: acción -> KEY   (ej: { LIST: "AGENCIES__LIST" })  ← lo que pasás al hook
    const CONSTANTS = Object.fromEntries(Object.entries(API).map(([k, v]) => [k, v.KEY]));

    // 🔥 ENDPOINTS: KEY -> URL (PLANO)   (ej: { "AGENCIES__LIST": "/agencies/list" })
    //    Es el registro que el hook resuelve con API_CORE.ENDPOINTS[key].
    const ENDPOINTS = Object.fromEntries(Object.values(API).map((v) => [v.KEY, v.URL]));

    return { API, PERMISSIONS, CONSTANTS, ENDPOINTS };
};